/**
 * @flow
 * @relayHash fd0efdc79d9cd77f98a670193c2e051e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type IBCashTransaction_all$ref = any;
type IBCorporateAction_all$ref = any;
type IBDividendAccrual_all$ref = any;
type IBSalesTax_all$ref = any;
type IBTransactionTax_all$ref = any;
export type AccountPortfolioHolding = {|
  accountId?: ?string,
  portfolioId?: ?string,
  holdingQty: string,
|};
export type AccountPortfolioHoldingCash = {|
  accountId?: ?string,
  portfolioId?: ?string,
  holdingQty?: ?string,
  currency?: ?string,
  cashQty: string,
|};
export type ProcessBrokerActivityMutationVariables = {|
  brokerActivityId: string,
  copyFromBrokerActivityId?: ?string,
  responsibleHoldings: $ReadOnlyArray<AccountPortfolioHolding>,
  selectiveDistribution?: ?$ReadOnlyArray<AccountPortfolioHoldingCash>,
  exDate?: ?any,
  payDate?: ?any,
  validateHolding?: ?boolean,
  siblingBrokerActivityId?: ?string,
  reverseWithBrokerActivityId?: ?string,
  toAccountId?: ?string,
  forceNoSibling?: ?boolean,
  holdingsDate?: ?any,
|};
export type ProcessBrokerActivityMutationResponse = {|
  +processBrokerActivity: ?{|
    +corporateAction: ?{|
      +$fragmentRefs: IBCorporateAction_all$ref
    |},
    +dividendAccrual: ?{|
      +$fragmentRefs: IBDividendAccrual_all$ref
    |},
    +cashTransaction: ?{|
      +$fragmentRefs: IBCashTransaction_all$ref
    |},
    +transactionTax: ?{|
      +$fragmentRefs: IBTransactionTax_all$ref
    |},
    +salesTax: ?{|
      +$fragmentRefs: IBSalesTax_all$ref
    |},
    +siblingCorporateAction: ?{|
      +$fragmentRefs: IBCorporateAction_all$ref
    |},
    +siblingCashTransaction: ?{|
      +$fragmentRefs: IBCashTransaction_all$ref
    |},
    +errors: ?$ReadOnlyArray<?{|
      +field: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type ProcessBrokerActivityMutation = {|
  variables: ProcessBrokerActivityMutationVariables,
  response: ProcessBrokerActivityMutationResponse,
|};
*/


/*
mutation ProcessBrokerActivityMutation(
  $brokerActivityId: ID!
  $copyFromBrokerActivityId: ID
  $responsibleHoldings: [AccountPortfolioHolding!]!
  $selectiveDistribution: [AccountPortfolioHoldingCash!]
  $exDate: Date
  $payDate: Date
  $validateHolding: Boolean
  $siblingBrokerActivityId: ID
  $reverseWithBrokerActivityId: ID
  $toAccountId: ID
  $forceNoSibling: Boolean
  $holdingsDate: Date
) {
  processBrokerActivity(brokerActivityId: $brokerActivityId, copyFromBrokerActivityId: $copyFromBrokerActivityId, responsibleHoldings: $responsibleHoldings, selectiveDistribution: $selectiveDistribution, exDate: $exDate, payDate: $payDate, validateHolding: $validateHolding, siblingBrokerActivityId: $siblingBrokerActivityId, reverseWithBrokerActivityId: $reverseWithBrokerActivityId, toAccountId: $toAccountId, forceNoSibling: $forceNoSibling, holdingsDate: $holdingsDate) {
    corporateAction: brokerActivity {
      __typename
      ... on IBCorporateActionNode {
        ...IBCorporateAction_all
      }
      ... on Node {
        id
      }
    }
    dividendAccrual: brokerActivity {
      __typename
      ... on IBDividendAccrualNode {
        ...IBDividendAccrual_all
      }
      ... on Node {
        id
      }
    }
    cashTransaction: brokerActivity {
      __typename
      ... on IBCashTransactionNode {
        ...IBCashTransaction_all
      }
      ... on Node {
        id
      }
    }
    transactionTax: brokerActivity {
      __typename
      ... on IBTransactionTaxNode {
        ...IBTransactionTax_all
      }
      ... on Node {
        id
      }
    }
    salesTax: brokerActivity {
      __typename
      ... on IBSalesTaxNode {
        ...IBSalesTax_all
      }
      ... on Node {
        id
      }
    }
    siblingCorporateAction: siblingBrokerActivity {
      __typename
      ... on IBCorporateActionNode {
        ...IBCorporateAction_all
      }
      ... on Node {
        id
      }
    }
    siblingCashTransaction: siblingBrokerActivity {
      __typename
      ... on IBCashTransactionNode {
        ...IBCashTransaction_all
      }
      ... on Node {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}

fragment IBCorporateAction_all on IBCorporateActionNode {
  id
  ignored
  processedAt
  processedBy {
    username
    fullName
    id
  }
  group {
    id
    description
  }
  transactionId
  ibConId
  currency
  description
  isin
  symbol
  transactionDatetime
  reportDate
  quantity
  proceeds
  type
  contract {
    id
    symbol
    currency
    ibConId
  }
  notes {
    id
  }
  brokeractivityPtr {
    id
    group {
      id
      description
    }
    responsiblecontract {
      contract {
        symbol
        id
        ibConId
        name
        currency
        exchange {
          name
          symbol
          id
        }
      }
      id
    }
    brokeractivitytransactionSet {
      edges {
        node {
          id
          account {
            name
            id
          }
          brokeractivitytransactioncontractdeltaSet {
            edges {
              node {
                portfolio {
                  id
                }
                contract {
                  id
                  symbol
                }
                quantity
                id
              }
            }
          }
          brokeractivitytransactioncashdeltaSet {
            edges {
              node {
                currency
                quantity
                id
              }
            }
          }
        }
      }
    }
  }
}

fragment IBDividendAccrual_all on IBDividendAccrualNode {
  id
  processedAt
  processedBy {
    username
    id
  }
  ignored
  ibConId
  currency
  description
  symbol
  reportDate
  quantity
  fxRateToBase
  assetCategory
  listingExchange
  multiplier
  date
  exDate
  payDate
  tax
  fee
  grossRate
  grossAmount
  netAmount
  code
  brokeractivityPtr {
    brokeractivitytransactionSet {
      edges {
        node {
          id
          account {
            name
            id
          }
          brokeractivitytransactioncontractdeltaSet {
            edges {
              node {
                portfolio {
                  id
                }
                contract {
                  id
                  symbol
                }
                quantity
                id
              }
            }
          }
          brokeractivitytransactioncashdeltaSet {
            edges {
              node {
                currency
                quantity
                portfolio {
                  id
                }
                id
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment IBCashTransaction_all on IBCashTransactionNode {
  id
  processedAt
  processedBy {
    username
    fullName
    id
  }
  group {
    id
    description
  }
  ignored
  ibConId
  currency
  description
  isin
  symbol
  transactionDate
  reportDate
  transactionId
  transType
  fxRateToBase
  assetCategory
  amount
  notes {
    id
  }
  contract {
    id
    ibConId
    currency
    symbol
  }
  brokeractivityPtr {
    group {
      id
      description
    }
    brokeractivitytransactionSet {
      edges {
        node {
          id
          account {
            id
            name
          }
          brokeractivitytransactioncontractdeltaSet {
            edges {
              node {
                portfolio {
                  id
                }
                contract {
                  id
                  symbol
                }
                quantity
                id
              }
            }
          }
          brokeractivitytransactioncashdeltaSet {
            edges {
              node {
                currency
                quantity
                id
              }
            }
          }
        }
      }
    }
    id
    responsiblecontract {
      id
      contract {
        id
        name
        ibConId
        symbol
        currency
        exchange {
          name
          symbol
          id
        }
      }
    }
  }
}

fragment IBTransactionTax_all on IBTransactionTaxNode {
  id
  processedAt
  processedBy {
    username
    id
  }
  notes {
    id
  }
  ignored
  ibConId
  currency
  taxAmount
  description
  tradeId
  isin
  symbol
  reportDate
  taxDescription
  brokeractivityPtr {
    brokeractivitytransactionSet {
      edges {
        node {
          id
          account {
            name
            id
          }
          brokeractivitytransactioncontractdeltaSet {
            edges {
              node {
                portfolio {
                  id
                }
                contract {
                  id
                  symbol
                }
                quantity
                id
              }
            }
          }
          brokeractivitytransactioncashdeltaSet {
            edges {
              node {
                currency
                quantity
                id
              }
            }
          }
        }
      }
    }
    id
  }
}

fragment IBSalesTax_all on IBSalesTaxNode {
  id
  processedAt
  processedBy {
    username
    fullName
    id
  }
  taxableDescription
  ignored
  currency
  salesTax
  reportDate
  updatedAt
  notes {
    id
  }
  brokeractivityPtr {
    brokeractivitytransactionSet {
      edges {
        node {
          id
          account {
            name
            id
          }
          brokeractivitytransactioncontractdeltaSet {
            edges {
              node {
                portfolio {
                  id
                }
                contract {
                  id
                  symbol
                }
                quantity
                id
              }
            }
          }
          brokeractivitytransactioncashdeltaSet {
            edges {
              node {
                currency
                quantity
                id
              }
            }
          }
        }
      }
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "brokerActivityId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "copyFromBrokerActivityId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "responsibleHoldings",
    "type": "[AccountPortfolioHolding!]!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "selectiveDistribution",
    "type": "[AccountPortfolioHoldingCash!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "exDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "payDate",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "validateHolding",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "siblingBrokerActivityId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "reverseWithBrokerActivityId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "toAccountId",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "forceNoSibling",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "holdingsDate",
    "type": "Date",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "brokerActivityId",
    "variableName": "brokerActivityId"
  },
  {
    "kind": "Variable",
    "name": "copyFromBrokerActivityId",
    "variableName": "copyFromBrokerActivityId"
  },
  {
    "kind": "Variable",
    "name": "exDate",
    "variableName": "exDate"
  },
  {
    "kind": "Variable",
    "name": "forceNoSibling",
    "variableName": "forceNoSibling"
  },
  {
    "kind": "Variable",
    "name": "holdingsDate",
    "variableName": "holdingsDate"
  },
  {
    "kind": "Variable",
    "name": "payDate",
    "variableName": "payDate"
  },
  {
    "kind": "Variable",
    "name": "responsibleHoldings",
    "variableName": "responsibleHoldings"
  },
  {
    "kind": "Variable",
    "name": "reverseWithBrokerActivityId",
    "variableName": "reverseWithBrokerActivityId"
  },
  {
    "kind": "Variable",
    "name": "selectiveDistribution",
    "variableName": "selectiveDistribution"
  },
  {
    "kind": "Variable",
    "name": "siblingBrokerActivityId",
    "variableName": "siblingBrokerActivityId"
  },
  {
    "kind": "Variable",
    "name": "toAccountId",
    "variableName": "toAccountId"
  },
  {
    "kind": "Variable",
    "name": "validateHolding",
    "variableName": "validateHolding"
  }
],
v2 = [
  {
    "kind": "InlineFragment",
    "type": "IBCorporateActionNode",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "IBCorporateAction_all",
        "args": null
      }
    ]
  }
],
v3 = [
  {
    "kind": "InlineFragment",
    "type": "IBCashTransactionNode",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "IBCashTransaction_all",
        "args": null
      }
    ]
  }
],
v4 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "errors",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "field",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "messages",
      "args": null,
      "storageKey": null
    }
  ]
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ignored",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "processedAt",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "processedBy",
  "storageKey": null,
  "args": null,
  "concreteType": "UserNode",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "fullName",
      "args": null,
      "storageKey": null
    },
    (v6/*: any*/)
  ]
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "group",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityGroupNode",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v11/*: any*/)
  ]
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "transactionId",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ibConId",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isin",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "symbol",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "reportDate",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v20 = [
  (v6/*: any*/)
],
v21 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "notes",
  "storageKey": null,
  "args": null,
  "concreteType": "NotesNode",
  "plural": false,
  "selections": (v20/*: any*/)
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "exchange",
  "storageKey": null,
  "args": null,
  "concreteType": "ExchangeNode",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v17/*: any*/),
    (v6/*: any*/)
  ]
},
v24 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "account",
  "storageKey": null,
  "args": null,
  "concreteType": "AccountNode",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v6/*: any*/)
  ]
},
v25 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "portfolio",
  "storageKey": null,
  "args": null,
  "concreteType": "PortfolioNode",
  "plural": false,
  "selections": (v20/*: any*/)
},
v26 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactioncontractdeltaSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionContractDeltaNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionContractDeltaNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionContractDeltaNode",
          "plural": false,
          "selections": [
            (v25/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "contract",
              "storageKey": null,
              "args": null,
              "concreteType": "ContractNode",
              "plural": false,
              "selections": [
                (v6/*: any*/),
                (v17/*: any*/)
              ]
            },
            (v19/*: any*/),
            (v6/*: any*/)
          ]
        }
      ]
    }
  ]
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactioncashdeltaSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionCashDeltaNode",
          "plural": false,
          "selections": [
            (v15/*: any*/),
            (v19/*: any*/),
            (v6/*: any*/)
          ]
        }
      ]
    }
  ]
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivitytransactionSet",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityTransactionNodeConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "BrokerActivityTransactionNodeEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "BrokerActivityTransactionNode",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v24/*: any*/),
            (v26/*: any*/),
            (v27/*: any*/)
          ]
        }
      ]
    }
  ]
},
v29 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "kind": "InlineFragment",
    "type": "IBCorporateActionNode",
    "selections": [
      (v7/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "transactionDatetime",
        "args": null,
        "storageKey": null
      },
      (v18/*: any*/),
      (v19/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "proceeds",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contract",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractNode",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v17/*: any*/),
          (v15/*: any*/),
          (v14/*: any*/)
        ]
      },
      (v21/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "brokeractivityPtr",
        "storageKey": null,
        "args": null,
        "concreteType": "BrokerActivityNode",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v12/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "responsiblecontract",
            "storageKey": null,
            "args": null,
            "concreteType": "ResponsibleContractNode",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractNode",
                "plural": false,
                "selections": [
                  (v17/*: any*/),
                  (v6/*: any*/),
                  (v14/*: any*/),
                  (v22/*: any*/),
                  (v15/*: any*/),
                  (v23/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          },
          (v28/*: any*/)
        ]
      }
    ]
  }
],
v30 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "processedBy",
  "storageKey": null,
  "args": null,
  "concreteType": "UserNode",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v6/*: any*/)
  ]
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fxRateToBase",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "assetCategory",
  "args": null,
  "storageKey": null
},
v33 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "kind": "InlineFragment",
    "type": "IBCashTransactionNode",
    "selections": [
      (v8/*: any*/),
      (v10/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "transactionDate",
        "args": null,
        "storageKey": null
      },
      (v18/*: any*/),
      (v13/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "transType",
        "args": null,
        "storageKey": null
      },
      (v31/*: any*/),
      (v32/*: any*/),
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
      },
      (v21/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "contract",
        "storageKey": null,
        "args": null,
        "concreteType": "ContractNode",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v17/*: any*/)
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "brokeractivityPtr",
        "storageKey": null,
        "args": null,
        "concreteType": "BrokerActivityNode",
        "plural": false,
        "selections": [
          (v12/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "brokeractivitytransactionSet",
            "storageKey": null,
            "args": null,
            "concreteType": "BrokerActivityTransactionNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "BrokerActivityTransactionNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityTransactionNode",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "account",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AccountNode",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v22/*: any*/)
                        ]
                      },
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          (v6/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "responsiblecontract",
            "storageKey": null,
            "args": null,
            "concreteType": "ResponsibleContractNode",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "contract",
                "storageKey": null,
                "args": null,
                "concreteType": "ContractNode",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v22/*: any*/),
                  (v14/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  }
],
v34 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "brokeractivityPtr",
  "storageKey": null,
  "args": null,
  "concreteType": "BrokerActivityNode",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    (v6/*: any*/)
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ProcessBrokerActivityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "processBrokerActivity",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessBrokerActivity",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "corporateAction",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "dividendAccrual",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "IBDividendAccrualNode",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "IBDividendAccrual_all",
                    "args": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "cashTransaction",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v3/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "transactionTax",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "IBTransactionTaxNode",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "IBTransactionTax_all",
                    "args": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "salesTax",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "type": "IBSalesTaxNode",
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "IBSalesTax_all",
                    "args": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "siblingCorporateAction",
            "name": "siblingBrokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "siblingCashTransaction",
            "name": "siblingBrokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v3/*: any*/)
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ProcessBrokerActivityMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "processBrokerActivity",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ProcessBrokerActivity",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": "corporateAction",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v29/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "dividendAccrual",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "IBDividendAccrualNode",
                "selections": [
                  (v8/*: any*/),
                  (v30/*: any*/),
                  (v7/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "listingExchange",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "multiplier",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "date",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "exDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "payDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "tax",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fee",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "grossRate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "grossAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "netAmount",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "code",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "brokeractivityPtr",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BrokerActivityNode",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "brokeractivitytransactionSet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "BrokerActivityTransactionNodeConnection",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "BrokerActivityTransactionNodeEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "BrokerActivityTransactionNode",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v24/*: any*/),
                                  (v26/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "brokeractivitytransactioncashdeltaSet",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BrokerActivityTransactionCashDeltaNodeConnection",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "edges",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "BrokerActivityTransactionCashDeltaNodeEdge",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "node",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "BrokerActivityTransactionCashDeltaNode",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v19/*: any*/),
                                              (v25/*: any*/),
                                              (v6/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "cashTransaction",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v33/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "transactionTax",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "IBTransactionTaxNode",
                "selections": [
                  (v8/*: any*/),
                  (v30/*: any*/),
                  (v21/*: any*/),
                  (v7/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "taxAmount",
                    "args": null,
                    "storageKey": null
                  },
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "tradeId",
                    "args": null,
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "taxDescription",
                    "args": null,
                    "storageKey": null
                  },
                  (v34/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "salesTax",
            "name": "brokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "IBSalesTaxNode",
                "selections": [
                  (v8/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "taxableDescription",
                    "args": null,
                    "storageKey": null
                  },
                  (v7/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesTax",
                    "args": null,
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "updatedAt",
                    "args": null,
                    "storageKey": null
                  },
                  (v21/*: any*/),
                  (v34/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": "siblingCorporateAction",
            "name": "siblingBrokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v29/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": "siblingCashTransaction",
            "name": "siblingBrokerActivity",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": (v33/*: any*/)
          },
          (v4/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "ProcessBrokerActivityMutation",
    "id": null,
    "text": "mutation ProcessBrokerActivityMutation(\n  $brokerActivityId: ID!\n  $copyFromBrokerActivityId: ID\n  $responsibleHoldings: [AccountPortfolioHolding!]!\n  $selectiveDistribution: [AccountPortfolioHoldingCash!]\n  $exDate: Date\n  $payDate: Date\n  $validateHolding: Boolean\n  $siblingBrokerActivityId: ID\n  $reverseWithBrokerActivityId: ID\n  $toAccountId: ID\n  $forceNoSibling: Boolean\n  $holdingsDate: Date\n) {\n  processBrokerActivity(brokerActivityId: $brokerActivityId, copyFromBrokerActivityId: $copyFromBrokerActivityId, responsibleHoldings: $responsibleHoldings, selectiveDistribution: $selectiveDistribution, exDate: $exDate, payDate: $payDate, validateHolding: $validateHolding, siblingBrokerActivityId: $siblingBrokerActivityId, reverseWithBrokerActivityId: $reverseWithBrokerActivityId, toAccountId: $toAccountId, forceNoSibling: $forceNoSibling, holdingsDate: $holdingsDate) {\n    corporateAction: brokerActivity {\n      __typename\n      ... on IBCorporateActionNode {\n        ...IBCorporateAction_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    dividendAccrual: brokerActivity {\n      __typename\n      ... on IBDividendAccrualNode {\n        ...IBDividendAccrual_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    cashTransaction: brokerActivity {\n      __typename\n      ... on IBCashTransactionNode {\n        ...IBCashTransaction_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    transactionTax: brokerActivity {\n      __typename\n      ... on IBTransactionTaxNode {\n        ...IBTransactionTax_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    salesTax: brokerActivity {\n      __typename\n      ... on IBSalesTaxNode {\n        ...IBSalesTax_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    siblingCorporateAction: siblingBrokerActivity {\n      __typename\n      ... on IBCorporateActionNode {\n        ...IBCorporateAction_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    siblingCashTransaction: siblingBrokerActivity {\n      __typename\n      ... on IBCashTransactionNode {\n        ...IBCashTransaction_all\n      }\n      ... on Node {\n        id\n      }\n    }\n    errors {\n      field\n      messages\n    }\n  }\n}\n\nfragment IBCorporateAction_all on IBCorporateActionNode {\n  id\n  ignored\n  processedAt\n  processedBy {\n    username\n    fullName\n    id\n  }\n  group {\n    id\n    description\n  }\n  transactionId\n  ibConId\n  currency\n  description\n  isin\n  symbol\n  transactionDatetime\n  reportDate\n  quantity\n  proceeds\n  type\n  contract {\n    id\n    symbol\n    currency\n    ibConId\n  }\n  notes {\n    id\n  }\n  brokeractivityPtr {\n    id\n    group {\n      id\n      description\n    }\n    responsiblecontract {\n      contract {\n        symbol\n        id\n        ibConId\n        name\n        currency\n        exchange {\n          name\n          symbol\n          id\n        }\n      }\n      id\n    }\n    brokeractivitytransactionSet {\n      edges {\n        node {\n          id\n          account {\n            name\n            id\n          }\n          brokeractivitytransactioncontractdeltaSet {\n            edges {\n              node {\n                portfolio {\n                  id\n                }\n                contract {\n                  id\n                  symbol\n                }\n                quantity\n                id\n              }\n            }\n          }\n          brokeractivitytransactioncashdeltaSet {\n            edges {\n              node {\n                currency\n                quantity\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment IBDividendAccrual_all on IBDividendAccrualNode {\n  id\n  processedAt\n  processedBy {\n    username\n    id\n  }\n  ignored\n  ibConId\n  currency\n  description\n  symbol\n  reportDate\n  quantity\n  fxRateToBase\n  assetCategory\n  listingExchange\n  multiplier\n  date\n  exDate\n  payDate\n  tax\n  fee\n  grossRate\n  grossAmount\n  netAmount\n  code\n  brokeractivityPtr {\n    brokeractivitytransactionSet {\n      edges {\n        node {\n          id\n          account {\n            name\n            id\n          }\n          brokeractivitytransactioncontractdeltaSet {\n            edges {\n              node {\n                portfolio {\n                  id\n                }\n                contract {\n                  id\n                  symbol\n                }\n                quantity\n                id\n              }\n            }\n          }\n          brokeractivitytransactioncashdeltaSet {\n            edges {\n              node {\n                currency\n                quantity\n                portfolio {\n                  id\n                }\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment IBCashTransaction_all on IBCashTransactionNode {\n  id\n  processedAt\n  processedBy {\n    username\n    fullName\n    id\n  }\n  group {\n    id\n    description\n  }\n  ignored\n  ibConId\n  currency\n  description\n  isin\n  symbol\n  transactionDate\n  reportDate\n  transactionId\n  transType\n  fxRateToBase\n  assetCategory\n  amount\n  notes {\n    id\n  }\n  contract {\n    id\n    ibConId\n    currency\n    symbol\n  }\n  brokeractivityPtr {\n    group {\n      id\n      description\n    }\n    brokeractivitytransactionSet {\n      edges {\n        node {\n          id\n          account {\n            id\n            name\n          }\n          brokeractivitytransactioncontractdeltaSet {\n            edges {\n              node {\n                portfolio {\n                  id\n                }\n                contract {\n                  id\n                  symbol\n                }\n                quantity\n                id\n              }\n            }\n          }\n          brokeractivitytransactioncashdeltaSet {\n            edges {\n              node {\n                currency\n                quantity\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n    responsiblecontract {\n      id\n      contract {\n        id\n        name\n        ibConId\n        symbol\n        currency\n        exchange {\n          name\n          symbol\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment IBTransactionTax_all on IBTransactionTaxNode {\n  id\n  processedAt\n  processedBy {\n    username\n    id\n  }\n  notes {\n    id\n  }\n  ignored\n  ibConId\n  currency\n  taxAmount\n  description\n  tradeId\n  isin\n  symbol\n  reportDate\n  taxDescription\n  brokeractivityPtr {\n    brokeractivitytransactionSet {\n      edges {\n        node {\n          id\n          account {\n            name\n            id\n          }\n          brokeractivitytransactioncontractdeltaSet {\n            edges {\n              node {\n                portfolio {\n                  id\n                }\n                contract {\n                  id\n                  symbol\n                }\n                quantity\n                id\n              }\n            }\n          }\n          brokeractivitytransactioncashdeltaSet {\n            edges {\n              node {\n                currency\n                quantity\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment IBSalesTax_all on IBSalesTaxNode {\n  id\n  processedAt\n  processedBy {\n    username\n    fullName\n    id\n  }\n  taxableDescription\n  ignored\n  currency\n  salesTax\n  reportDate\n  updatedAt\n  notes {\n    id\n  }\n  brokeractivityPtr {\n    brokeractivitytransactionSet {\n      edges {\n        node {\n          id\n          account {\n            name\n            id\n          }\n          brokeractivitytransactioncontractdeltaSet {\n            edges {\n              node {\n                portfolio {\n                  id\n                }\n                contract {\n                  id\n                  symbol\n                }\n                quantity\n                id\n              }\n            }\n          }\n          brokeractivitytransactioncashdeltaSet {\n            edges {\n              node {\n                currency\n                quantity\n                id\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '07b39528089aaa7686d785272f843d08';
module.exports = node;
